import React from 'react'
import LgyLoadingIcon from 'app/components/util/lgy-loading-icon/LgyLoadingIcon'

/**
 * Displays a loading icon while data is still loading, or an error message if data fails to load. 
 * Content should be included as children.
 * 
 * @author Alex Clary
 * 
 * @param props.isLoading will display a loading icon if isLoading is true
 * @param [props.isError] will display a brief error message if true. If you want you render your own error message inside the child component, do not provide a value or hardcode to false.
 * @param props.children what to render when isLoading and isError are false
 * 
 * @todo TODO: perhaps combine with Authorize somewhat, maybe convert to react suspense, maybe involve caching
 */
const LgyLoadingFallback = ({ isLoading, isError, children }) =>
  isLoading
    ? <LgyLoadingIcon />
    : isError
      ? <div>Error loading data</div>
      : children

export default LgyLoadingFallback